var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('data-table',{attrs:{"api":"/api/admin/games","title":_vm.$t('Games'),"headers":_vm.headers,"filters":['period', 'game', 'user-role', 'game-result'],"search":true,"search-placeholder":_vm.$t('Game ID, user name or email')},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('user-link',{attrs:{"user":item.account.user}})]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('game-menu',{attrs:{"id":item.id,"small":""}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }